var _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon3PartDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PlayerAccount_Tabs_3dots",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12178",
    "data-name": "Rectangle 12178",
    width: 24,
    height: 24,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_456",
    "data-name": "Ellipse 456",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "rotate(90 4 10)",
    fill: "#999"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_457",
    "data-name": "Ellipse 457",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "rotate(90 1.5 12.5)",
    fill: "#999"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_458",
    "data-name": "Ellipse 458",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "rotate(90 -1 15)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon3PartDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_3part_dots.fcc30e303cbbfff1d87580e65627ed00.svg";